module.exports = __webpack_public_path__ + "static/media/AIRTEL.c9fec86e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discos/AIRTEL.svg
// module id = 381
// module chunks = 25